import styles from './styles';

interface IToggleProps {
  toggleOn: boolean;
  toggleEnabled: boolean;
  onToggle: () => void;
}

const Toggle = ({ toggleOn, toggleEnabled, onToggle }: IToggleProps): JSX.Element => {
  return (
    <label className="toggle" css={styles.container}>
      <input
        type="checkbox"
        css={styles.input}
        checked={toggleOn}
        onChange={onToggle}
        disabled={!toggleEnabled}
      />
      <span className="slider" css={toggleOn ? styles.sliderOn : styles.sliderOff}>
        {toggleOn ? 'ON' : 'OFF'}
      </span>
    </label>
  );
};

export default Toggle;
